export default __webpack_public_path__ + "static/media/Create-documentation.1fcaf3c4.md";